import { useEffect } from 'react';

const isFocusedNumberInput = (target) =>
  target instanceof HTMLInputElement &&
  target.type === 'number' &&
  document.activeElement === target;

/** Block trackpad/mouse wheel from incrementing a focused number input. */
export const preventNumberInputWheelChange = (event) => {
  if (isFocusedNumberInput(event.target)) {
    event.preventDefault();
  }
};

/**
 * Attach to a dashboard container so all nested `input[type=number]` ignore wheel/trackpad scroll.
 */
export const useBlockNumberInputWheel = (containerRef) => {
  useEffect(() => {
    const root = containerRef?.current;
    if (!root) return undefined;

    const onWheel = (event) => preventNumberInputWheelChange(event);

    root.addEventListener('wheel', onWheel, { passive: false, capture: true });
    return () => root.removeEventListener('wheel', onWheel, { capture: true });
  }, [containerRef]);
};

/** Optional spread for standalone number inputs (e.g. modals outside the dashboard root). */
export const numberInputWheelProps = {
  onWheel: (event) => {
    if (document.activeElement === event.currentTarget) {
      event.preventDefault();
    }
  }
};
